// removed by extract-text-webpack-plugin
module.exports = {"badge":"_3tRRAQ3hCssGzYTHWSrKk2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/appList/Badge.css
// module id = 159
// module chunks = 0